if (!customElements.get("m-media-logos")) {
  class MMediaLogos extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.mediaQuery = window.matchMedia("(max-width: 767px)");
      this.handleMediaChange = this.handleMediaChange.bind(this);
    }

    connectedCallback() {
      this.swiperContainer = this.querySelector(".m-media-logos__swiper");
      this.staticEl = this.querySelector(".m-media-logos__static");
      this.marqueeEl = this.querySelector(".m-media-logos__marquee");

      this.syncAria();
      this.handleMediaChange();

      if (this.mediaQuery.addEventListener) {
        this.mediaQuery.addEventListener("change", this.handleMediaChange);
      } else {
        this.mediaQuery.addListener(this.handleMediaChange);
      }

      if (Shopify.designMode) {
        this._onSectionLoad = () => this.handleMediaChange();
        document.addEventListener("shopify:section:load", this._onSectionLoad);
      }
    }

    disconnectedCallback() {
      this.destroySlider();

      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener("change", this.handleMediaChange);
      } else {
        this.mediaQuery.removeListener(this.handleMediaChange);
      }

      if (this._onSectionLoad) {
        document.removeEventListener("shopify:section:load", this._onSectionLoad);
      }
    }

    handleMediaChange() {
      this.syncAria();

      if (this.mediaQuery.matches) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    syncAria() {
      const isMobile = this.mediaQuery.matches;
      if (this.staticEl) {
        this.staticEl.setAttribute("aria-hidden", isMobile ? "true" : "false");
      }
      if (this.marqueeEl) {
        this.marqueeEl.setAttribute("aria-hidden", isMobile ? "false" : "true");
      }
    }

    initSlider() {
      if (!this.swiperContainer || this.slider) return;
      if (typeof MinimogLibs === "undefined" || !MinimogLibs.Swiper) {
        requestAnimationFrame(() => this.initSlider());
        return;
      }

      const speedSeconds = parseInt(this.dataset.speed, 10) || 4;
      const speed = speedSeconds * 1000;
      const spaceBetween = parseInt(this.dataset.gapMobile, 10) || 32;

      this.slider = new MinimogLibs.Swiper(this.swiperContainer, {
        slidesPerView: "auto",
        spaceBetween,
        loop: true,
        speed,
        allowTouchMove: true,
        grabCursor: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        freeMode: false,
        watchSlidesProgress: true,
        on: {
          init: (swiper) => {
            if (swiper.wrapperEl) {
              swiper.wrapperEl.style.transitionTimingFunction = "linear";
            }
          },
        },
      });
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  }

  customElements.define("m-media-logos", MMediaLogos);
}
